import { FormattedMessage } from "react-intl";

import styles from "@components/ClientVisibleTaskResourceUsefulnessButtons.module.css";
import IconBase from "@components/text/IconBase";
import ButtonLink from "@components/typography/ButtonLink";
import { ResourceFragment } from "@typing/Generated";

type Props = {
  resource: ResourceFragment;
  updateUseful: (resource: ResourceFragment, useful: boolean) => void;
};

const ClientVisibleTaskResourceUsefulnessButtons = ({ resource, updateUseful }: Props) => (
  <div className="flex items-center justify-around gap-lg full-width-md-down">
    <ButtonLink
      className={`${styles.usefulnessButton} flex items-center gap-xs no-wrap`}
      data-testid="mark-useful"
      disabled={resource.useful === true}
      onClick={() => updateUseful(resource, true)}
      stylized={false}
    >
      <IconBase icon="checkmark" slot="start" />
      <FormattedMessage id="components.ClientVisibleTaskResourceUsefulnessButtons.yes" />
    </ButtonLink>
    {resource.useful !== false && (
      <ButtonLink
        className={`${styles.usefulnessButton} flex items-center gap-xs no-wrap`}
        data-testid="mark-not-useful"
        onClick={() => updateUseful(resource, false)}
        stylized={false}
      >
        <IconBase icon="xmark" slot="start" />
        <FormattedMessage id="components.ClientVisibleTaskResourceUsefulnessButtons.no" />
      </ButtonLink>
    )}
  </div>
);

export default ClientVisibleTaskResourceUsefulnessButtons;
